// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Products (redesign) — the catalogue at /products, its detail drawer,
   and the product editor at /products/new and /products/:id/edit.
   Depends on dashboard-redesign.css for the shell tokens and shared
   .rf-btn / .rf-num / .rf-spacer / .rf-empty, and on new-order.css for
   the shared form vocabulary (.rf-field / .rf-label / .rf-input-shell /
   .rf-grid-2). */

.pr-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* ---------------- toolbar ---------------- */
.pr-bar {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.pr-search {
  height: 34px;
  min-width: 250px;
  flex-grow: 1;
  max-width: 380px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.pr-search input {
  border: none;
  outline: none;
  background: none;
  width: 100%;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.pr-search-icon {
  width: 11px;
  height: 11px;
  border: 1.6px solid #a29b8d;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}
.pr-search-icon::after {
  content: "";
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: 5px;
  height: 1.6px;
  background: #a29b8d;
  transform: rotate(45deg);
}
.pr-count {
  font-size: 12.5px;
  color: #8b8477;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* type filter rail — driven by settings.product_types, not a hard-coded
   list like the legacy page's nine buttons */
.pr-types {
  padding: 12px 28px 0;
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.pr-type {
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid #e2dcd0;
  background: #fff;
  color: #6f6a60;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.pr-type:hover {
  border-color: #d8cfb8;
  background: #fdfbf6;
}
.pr-type.is-active {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
  color: #fff;
}
/* ---------------- grid ---------------- */
.pr-body {
  flex-grow: 1;
  min-height: 0;
  padding: 16px 28px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.pr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(216px, 1fr));
  gap: 14px;
}

.pr-card {
  text-align: left;
  font: inherit;
  padding: 0;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: box-shadow 160ms, border-color 160ms, transform 160ms;
}
.pr-card:hover {
  border-color: #d8cfb8;
  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.11);
  transform: translateY(-2px);
}
.pr-card.is-active {
  border-color: var(--rf-brand-lite);
  box-shadow: 0 0 0 2px rgba(var(--rf-brand-lite-rgb), 0.22);
}
.pr-thumb {
  position: relative;
  aspect-ratio: 4 / 3;
  background: #f4f1ea center / cover no-repeat;
  border-bottom: 1px solid #f0ece3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d3cbb8;
  font-size: 40px;
  flex-shrink: 0;
}
.pr-code {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 7px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #e2dcd0;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #4a453c;
  font-variant-numeric: tabular-nums;
}
.pr-card-body {
  padding: 11px 13px 12px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  flex-grow: 1;
}
.pr-name {
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.35;
  color: #191714;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.pr-meta {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.pr-tag {
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-edge);
  font-size: 10.5px;
  font-weight: 600;
  color: var(--rf-brand-deep);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
}
.pr-price {
  margin-left: auto;
  font-size: 13px;
  font-weight: 700;
  color: #191714;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.pr-price.is-empty {
  font-weight: 400;
  color: #c4bdad;
}
.pr-sizes {
  font-size: 11px;
  color: #a29b8d;
  font-variant-numeric: tabular-nums;
}

/* ---------------- pagination ---------------- */
.pr-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.pr-pager button {
  min-width: 32px;
  height: 32px;
  padding: 0 9px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  color: #4a453c;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
  font-variant-numeric: tabular-nums;
}
.pr-pager button:hover:not(:disabled) {
  background: #f6f4ef;
}
.pr-pager button.is-active {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
  color: #fff;
}
.pr-pager button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ================= detail drawer ================= */
.pd-wrap {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  justify-content: flex-end;
}
.pd-scrim {
  position: absolute;
  inset: 0;
  background: rgba(25, 23, 20, 0.2);
}
.pd-panel {
  position: relative;
  width: 480px;
  max-width: 100%;
  background: #fff;
  border-left: 1px solid #ddd7cb;
  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.16);
  display: flex;
  flex-direction: column;
}
.pd-head {
  padding: 16px 20px;
  border-bottom: 1px solid #e2dcd0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
  text-align: left;
  font-weight: 400;
  margin: 0;
}
.pd-head-main {
  min-width: 0;
  flex-grow: 1;
}
.pd-eyebrow {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
}
.pd-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 25px;
  font-weight: 400;
  line-height: 1.14;
  color: #191714;
  margin: 2px 0 0;
}
.pd-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.pd-icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2dcd0;
  background: #fff;
  color: #6f6a60;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.pd-icon-btn:hover {
  background: #f6f4ef;
  color: #191714;
}
.pd-icon-btn.is-danger:hover {
  background: #f7ebe9;
  border-color: #e3b9b4;
  color: #a8483e;
}
.pd-confirm {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 20px;
  background: #f7ebe9;
  border-bottom: 1px solid #e3b9b4;
  font-size: 12.5px;
  color: #7d332b;
  flex-shrink: 0;
}
.pd-btn-danger {
  border: none;
  background: #a8483e;
  color: #fff;
  padding: 0 14px;
}
.pd-btn-danger:hover:not(:disabled) {
  background: #8f3c33;
}
.pd-btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.pd-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 18px 20px 24px;
}
.pd-hero {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  border: 1px solid #e7e3da;
  background: #f4f1ea center / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d3cbb8;
  font-size: 56px;
  margin-bottom: 16px;
}
.pd-sec {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
  margin: 18px 0 9px;
}
.pd-sec:first-child {
  margin-top: 0;
}
.pd-facts {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 7px 12px;
  font-size: 12.5px;
}
.pd-facts dt {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #bdb6a7;
  padding-top: 2px;
  margin: 0;
}
.pd-facts dd {
  margin: 0;
  color: #4a453c;
  overflow-wrap: anywhere;
}
.pd-facts dd.is-empty {
  color: #c4bdad;
}

/* size tabs + their flower content */
.pd-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.pd-tab {
  border: 1px solid #e2dcd0;
  background: #fff;
  border-radius: 8px;
  padding: 6px 11px;
  cursor: pointer;
  font: inherit;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  min-width: 78px;
}
.pd-tab:hover {
  border-color: #d8cfb8;
}
.pd-tab.is-active {
  border-color: var(--rf-brand-lite);
  background: #fdfbf6;
}
.pd-tab-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #a29b8d;
}
.pd-tab.is-active .pd-tab-k {
  color: var(--rf-brand);
}
.pd-tab-v {
  font-size: 14px;
  font-weight: 700;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.pd-flowers {
  border: 1px solid #e7e3da;
  border-radius: 10px;
  overflow: hidden;
}
.pd-flower {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-bottom: 1px solid #f0ece3;
  font-size: 12.5px;
}
.pd-flower:last-child {
  border-bottom: none;
}
.pd-flower-n {
  width: 18px;
  font-size: 11px;
  color: #c4bdad;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}
.pd-flower-name {
  flex-grow: 1;
  min-width: 0;
  color: #191714;
}
.pd-flower-amt {
  font-weight: 700;
  color: var(--rf-brand-deep);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* ================= editor ================= */
.pe-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.pe-bar {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 11px 28px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 20;
}
.pe-back {
  height: 34px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  color: #6f6a60;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.pe-back:hover {
  background: #f6f4ef;
  color: #191714;
}
.pe-heading {
  min-width: 0;
}
.pe-eyebrow {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #bdb6a7;
}
.pe-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 21px;
  line-height: 1.14;
  color: #191714;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pe-body {
  flex-grow: 1;
  min-height: 0;
  padding: 18px 28px 32px;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}
.pe-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}
.pe-card {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
}
.pe-card-head {
  padding: 12px 18px;
  border-bottom: 1px solid #e7e3da;
  background: #fdfcfa;
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.pe-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #191714;
}
.pe-card-note {
  font-size: 11.5px;
  color: #a29b8d;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}
.pe-card-body {
  padding: 16px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* the add-a-row strip inside sizes / flower content */
.pe-add {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 116px auto;
  gap: 10px;
  align-items: end;
}
.pe-add .rf-btn {
  height: 38px;
}
.pe-rows {
  border: 1px solid #e7e3da;
  border-radius: 10px;
  overflow: hidden;
}
.pe-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid #f0ece3;
  font-size: 12.5px;
}
.pe-row:last-child {
  border-bottom: none;
}
.pe-row.is-editing {
  background: #fdfbf6;
}
.pe-row-k {
  flex-grow: 1;
  min-width: 0;
  font-weight: 600;
  color: #191714;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pe-row-v {
  font-weight: 700;
  color: var(--rf-brand-deep);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.pe-row-acts {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.pe-mini {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background: none;
  color: #a29b8d;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.pe-mini:hover {
  background: #f4f1ea;
  color: #191714;
}
.pe-mini.is-danger:hover {
  background: #f7ebe9;
  color: #a8483e;
}
.pe-empty {
  padding: 16px 12px;
  text-align: center;
  font-size: 12px;
  color: #bdb6a7;
}

/* size tabs inside the flower content card */
.pe-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.pe-tab {
  border: 1px solid #e2dcd0;
  background: #fff;
  border-radius: 8px;
  padding: 5px 11px;
  cursor: pointer;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #6f6a60;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.pe-tab:hover {
  border-color: #d8cfb8;
}
.pe-tab.is-active {
  border-color: var(--rf-brand-lite);
  background: #fdfbf6;
  color: #191714;
}
.pe-tab-n {
  font-size: 10.5px;
  font-weight: 700;
  color: #bdb6a7;
  font-variant-numeric: tabular-nums;
}
.pe-tab.is-active .pe-tab-n {
  color: var(--rf-brand);
}

/* image card — preview beside the controls, not a full-width slab that
   out-sizes the details card next to it */
.pe-photo {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
}
.pe-preview {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  border: 1px solid #e7e3da;
  background: #f4f1ea center / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d3cbb8;
  font-size: 40px;
}
.pe-drop {
  border: 1px dashed #ddd7cb;
  border-radius: 10px;
  background: #fdfcfa;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}
.pe-drop-hint {
  font-size: 12px;
  line-height: 1.5;
  color: #8b8477;
}
.pe-drop input[type="file"] {
  font: 400 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #6f6a60;
  max-width: 100%;
}

@media (max-width: 1100px) {
  .pe-body {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 620px) {
  .pe-photo {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 860px) {
  .pr-bar,
  .pr-types,
  .pr-body,
  .pe-bar,
  .pe-body {
    padding-left: 16px;
    padding-right: 16px;
  }
  .pe-add {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/products.css"],"names":[],"mappings":"AAAA;;;;;iBAKiB;;AAEjB;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;6CAC6C;AAC7C;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,8DAA8D;EAC9D,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,iEAAiE;AACnE;AACA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,0DAA0D;AAC5D;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,SAAS;EACT,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,8DAA8D;EAC9D,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,8DAA8D;EAC9D,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,sBAAsB;AACxB;;AAEA;0CAC0C;AAC1C;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8DAA8D;EAC9D,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Products (redesign) — the catalogue at /products, its detail drawer,\n   and the product editor at /products/new and /products/:id/edit.\n   Depends on dashboard-redesign.css for the shell tokens and shared\n   .rf-btn / .rf-num / .rf-spacer / .rf-empty, and on new-order.css for\n   the shared form vocabulary (.rf-field / .rf-label / .rf-input-shell /\n   .rf-grid-2). */\n\n.pr-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ---------------- toolbar ---------------- */\n.pr-bar {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n.pr-search {\n  height: 34px;\n  min-width: 250px;\n  flex-grow: 1;\n  max-width: 380px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.pr-search input {\n  border: none;\n  outline: none;\n  background: none;\n  width: 100%;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.pr-search-icon {\n  width: 11px;\n  height: 11px;\n  border: 1.6px solid #a29b8d;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n}\n.pr-search-icon::after {\n  content: \"\";\n  position: absolute;\n  right: -4px;\n  bottom: -3px;\n  width: 5px;\n  height: 1.6px;\n  background: #a29b8d;\n  transform: rotate(45deg);\n}\n.pr-count {\n  font-size: 12.5px;\n  color: #8b8477;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n/* type filter rail — driven by settings.product_types, not a hard-coded\n   list like the legacy page's nine buttons */\n.pr-types {\n  padding: 12px 28px 0;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n.pr-type {\n  height: 28px;\n  padding: 0 12px;\n  border-radius: 999px;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  color: #6f6a60;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.pr-type:hover {\n  border-color: #d8cfb8;\n  background: #fdfbf6;\n}\n.pr-type.is-active {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n  color: #fff;\n}\n/* ---------------- grid ---------------- */\n.pr-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 16px 28px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.pr-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(216px, 1fr));\n  gap: 14px;\n}\n\n.pr-card {\n  text-align: left;\n  font: inherit;\n  padding: 0;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 160ms, border-color 160ms, transform 160ms;\n}\n.pr-card:hover {\n  border-color: #d8cfb8;\n  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.11);\n  transform: translateY(-2px);\n}\n.pr-card.is-active {\n  border-color: var(--rf-brand-lite);\n  box-shadow: 0 0 0 2px rgba(var(--rf-brand-lite-rgb), 0.22);\n}\n.pr-thumb {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  background: #f4f1ea center / cover no-repeat;\n  border-bottom: 1px solid #f0ece3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d3cbb8;\n  font-size: 40px;\n  flex-shrink: 0;\n}\n.pr-code {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  padding: 2px 7px;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid #e2dcd0;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #4a453c;\n  font-variant-numeric: tabular-nums;\n}\n.pr-card-body {\n  padding: 11px 13px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  flex-grow: 1;\n}\n.pr-name {\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: #191714;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.pr-meta {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.pr-tag {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-edge);\n  font-size: 10.5px;\n  font-weight: 600;\n  color: var(--rf-brand-deep);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 60%;\n}\n.pr-price {\n  margin-left: auto;\n  font-size: 13px;\n  font-weight: 700;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.pr-price.is-empty {\n  font-weight: 400;\n  color: #c4bdad;\n}\n.pr-sizes {\n  font-size: 11px;\n  color: #a29b8d;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------------- pagination ---------------- */\n.pr-pager {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n.pr-pager button {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 9px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  color: #4a453c;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n  font-variant-numeric: tabular-nums;\n}\n.pr-pager button:hover:not(:disabled) {\n  background: #f6f4ef;\n}\n.pr-pager button.is-active {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n  color: #fff;\n}\n.pr-pager button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ================= detail drawer ================= */\n.pd-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  display: flex;\n  justify-content: flex-end;\n}\n.pd-scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(25, 23, 20, 0.2);\n}\n.pd-panel {\n  position: relative;\n  width: 480px;\n  max-width: 100%;\n  background: #fff;\n  border-left: 1px solid #ddd7cb;\n  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.16);\n  display: flex;\n  flex-direction: column;\n}\n.pd-head {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2dcd0;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex-shrink: 0;\n  text-align: left;\n  font-weight: 400;\n  margin: 0;\n}\n.pd-head-main {\n  min-width: 0;\n  flex-grow: 1;\n}\n.pd-eyebrow {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.pd-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 25px;\n  font-weight: 400;\n  line-height: 1.14;\n  color: #191714;\n  margin: 2px 0 0;\n}\n.pd-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.pd-icon-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  color: #6f6a60;\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.pd-icon-btn:hover {\n  background: #f6f4ef;\n  color: #191714;\n}\n.pd-icon-btn.is-danger:hover {\n  background: #f7ebe9;\n  border-color: #e3b9b4;\n  color: #a8483e;\n}\n.pd-confirm {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 20px;\n  background: #f7ebe9;\n  border-bottom: 1px solid #e3b9b4;\n  font-size: 12.5px;\n  color: #7d332b;\n  flex-shrink: 0;\n}\n.pd-btn-danger {\n  border: none;\n  background: #a8483e;\n  color: #fff;\n  padding: 0 14px;\n}\n.pd-btn-danger:hover:not(:disabled) {\n  background: #8f3c33;\n}\n.pd-btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.pd-body {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 18px 20px 24px;\n}\n.pd-hero {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 10px;\n  border: 1px solid #e7e3da;\n  background: #f4f1ea center / cover no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d3cbb8;\n  font-size: 56px;\n  margin-bottom: 16px;\n}\n.pd-sec {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  margin: 18px 0 9px;\n}\n.pd-sec:first-child {\n  margin-top: 0;\n}\n.pd-facts {\n  display: grid;\n  grid-template-columns: 96px minmax(0, 1fr);\n  gap: 7px 12px;\n  font-size: 12.5px;\n}\n.pd-facts dt {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n  padding-top: 2px;\n  margin: 0;\n}\n.pd-facts dd {\n  margin: 0;\n  color: #4a453c;\n  overflow-wrap: anywhere;\n}\n.pd-facts dd.is-empty {\n  color: #c4bdad;\n}\n\n/* size tabs + their flower content */\n.pd-tabs {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n}\n.pd-tab {\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  border-radius: 8px;\n  padding: 6px 11px;\n  cursor: pointer;\n  font: inherit;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1px;\n  min-width: 78px;\n}\n.pd-tab:hover {\n  border-color: #d8cfb8;\n}\n.pd-tab.is-active {\n  border-color: var(--rf-brand-lite);\n  background: #fdfbf6;\n}\n.pd-tab-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.pd-tab.is-active .pd-tab-k {\n  color: var(--rf-brand);\n}\n.pd-tab-v {\n  font-size: 14px;\n  font-weight: 700;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.pd-flowers {\n  border: 1px solid #e7e3da;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.pd-flower {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  border-bottom: 1px solid #f0ece3;\n  font-size: 12.5px;\n}\n.pd-flower:last-child {\n  border-bottom: none;\n}\n.pd-flower-n {\n  width: 18px;\n  font-size: 11px;\n  color: #c4bdad;\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n.pd-flower-name {\n  flex-grow: 1;\n  min-width: 0;\n  color: #191714;\n}\n.pd-flower-amt {\n  font-weight: 700;\n  color: var(--rf-brand-deep);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n/* ================= editor ================= */\n.pe-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.pe-bar {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 11px 28px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n.pe-back {\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  color: #6f6a60;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.pe-back:hover {\n  background: #f6f4ef;\n  color: #191714;\n}\n.pe-heading {\n  min-width: 0;\n}\n.pe-eyebrow {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n}\n.pe-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 21px;\n  line-height: 1.14;\n  color: #191714;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.pe-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 18px 28px 32px;\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);\n  gap: 16px;\n  align-items: start;\n}\n.pe-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n.pe-card {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.pe-card-head {\n  padding: 12px 18px;\n  border-bottom: 1px solid #e7e3da;\n  background: #fdfcfa;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n.pe-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #191714;\n}\n.pe-card-note {\n  font-size: 11.5px;\n  color: #a29b8d;\n  margin-left: auto;\n  font-variant-numeric: tabular-nums;\n}\n.pe-card-body {\n  padding: 16px 18px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* the add-a-row strip inside sizes / flower content */\n.pe-add {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 116px auto;\n  gap: 10px;\n  align-items: end;\n}\n.pe-add .rf-btn {\n  height: 38px;\n}\n.pe-rows {\n  border: 1px solid #e7e3da;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.pe-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border-bottom: 1px solid #f0ece3;\n  font-size: 12.5px;\n}\n.pe-row:last-child {\n  border-bottom: none;\n}\n.pe-row.is-editing {\n  background: #fdfbf6;\n}\n.pe-row-k {\n  flex-grow: 1;\n  min-width: 0;\n  font-weight: 600;\n  color: #191714;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.pe-row-v {\n  font-weight: 700;\n  color: var(--rf-brand-deep);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.pe-row-acts {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.pe-mini {\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  border: none;\n  background: none;\n  color: #a29b8d;\n  font-size: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.pe-mini:hover {\n  background: #f4f1ea;\n  color: #191714;\n}\n.pe-mini.is-danger:hover {\n  background: #f7ebe9;\n  color: #a8483e;\n}\n.pe-empty {\n  padding: 16px 12px;\n  text-align: center;\n  font-size: 12px;\n  color: #bdb6a7;\n}\n\n/* size tabs inside the flower content card */\n.pe-tabs {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.pe-tab {\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  border-radius: 8px;\n  padding: 5px 11px;\n  cursor: pointer;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #6f6a60;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.pe-tab:hover {\n  border-color: #d8cfb8;\n}\n.pe-tab.is-active {\n  border-color: var(--rf-brand-lite);\n  background: #fdfbf6;\n  color: #191714;\n}\n.pe-tab-n {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #bdb6a7;\n  font-variant-numeric: tabular-nums;\n}\n.pe-tab.is-active .pe-tab-n {\n  color: var(--rf-brand);\n}\n\n/* image card — preview beside the controls, not a full-width slab that\n   out-sizes the details card next to it */\n.pe-photo {\n  display: grid;\n  grid-template-columns: 190px minmax(0, 1fr);\n  gap: 14px;\n  align-items: start;\n}\n.pe-preview {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  border-radius: 10px;\n  border: 1px solid #e7e3da;\n  background: #f4f1ea center / cover no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d3cbb8;\n  font-size: 40px;\n}\n.pe-drop {\n  border: 1px dashed #ddd7cb;\n  border-radius: 10px;\n  background: #fdfcfa;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n.pe-drop-hint {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #8b8477;\n}\n.pe-drop input[type=\"file\"] {\n  font: 400 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #6f6a60;\n  max-width: 100%;\n}\n\n@media (max-width: 1100px) {\n  .pe-body {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 620px) {\n  .pe-photo {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 860px) {\n  .pr-bar,\n  .pr-types,\n  .pr-body,\n  .pe-bar,\n  .pe-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .pe-add {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
